export enum TABS {
  CUSTOM_PARAMETERS = 'customParameters',
  LIMITS = 'limits',
  PAYMENT_INSTRUMENTS = 'paymentInstruments',
  ROUTING_PRIORITIES = 'routingPriorities',
  ROUTING_STATS = 'routingStats',
  SAVED_CARD_TOKENS = 'savedCardTokens',
  STATISTIC = 'statistic',
  TRAFFIC = 'traffic',
  TRANSACTIONS = 'transactions',
}
